import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'

import { rootReducer } from '../reducers/'

import { httpRequest, authMiddleware, userProfileMiddleware, conversationMiddleware, messagingMiddleware, addContactMiddleware } from '../middleware';

const configureStore = preloadedState => {
  const store = createStore(
    rootReducer,
    preloadedState,
    compose(
      applyMiddleware(thunk, httpRequest, authMiddleware, userProfileMiddleware, addContactMiddleware, conversationMiddleware, messagingMiddleware, createLogger()),
    )
  )

  return store
}

var preloadedState = {
  user: {

  }
}

const jitsuChatStateKey = 'chat.jitsu.ninja.preloadedState';

var StoredState = localStorage.getItem(jitsuChatStateKey) || JSON.stringify(preloadedState);

preloadedState = JSON.parse(StoredState)

console.log(' preloadedState ', preloadedState)

preloadedState = {
  ...preloadedState
}

export const store = configureStore(preloadedState);

store.subscribe(() => {

  var state = store.getState();

  localStorage.setItem(jitsuChatStateKey, JSON.stringify({
    ...state,
    messaginScreen: {
      ...state.messaginScreen,
      videoChatId: null
    }

  }))

})


// WEBPACK FOOTER //
// ./src/Store/index.js